import React from 'react'
import expertError from "../error/image/Error-expert.png"
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
function ErrorBoundaryComponent() {
  const navigate = useNavigate()
  return (
    <div className='m-auto w-full flex flex-col justify-center items-center gap-5 '>
        <img  src={expertError} alt=''/>
        <h2 className='text-4xl'>مشکلی پیش آمده است!</h2>
        <Button onClick={()=>{
          navigate("/")
          window.location.reload()
        }} className='w-1/3 text-2xl h-fit '>بازگشت</Button>
    </div>
  )
}

export default ErrorBoundaryComponent